/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemoryControllerUpdateMutationRequest, AgentMemoryControllerUpdateMutationResponse, AgentMemoryControllerUpdatePathParams, AgentMemoryControllerUpdate400, AgentMemoryControllerUpdate401, AgentMemoryControllerUpdate403, AgentMemoryControllerUpdate404 } from "../../models/agentMemoriesController/AgentMemoryControllerUpdate";

function getAgentMemoryControllerUpdateUrl(id: AgentMemoryControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/agent-memories/${id}` as const }  
  return res
}

/**
 * @summary Update an AI agent memory profile
 * {@link /api/v1/agent-memories/:id}
 */
export async function agentMemoryControllerUpdate(id: AgentMemoryControllerUpdatePathParams["id"], data?: AgentMemoryControllerUpdateMutationRequest, config: Partial<RequestConfig<AgentMemoryControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AgentMemoryControllerUpdateMutationResponse, ResponseErrorConfig<AgentMemoryControllerUpdate400 | AgentMemoryControllerUpdate401 | AgentMemoryControllerUpdate403 | AgentMemoryControllerUpdate404>, AgentMemoryControllerUpdateMutationRequest>({ method : "PATCH", url : getAgentMemoryControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}